<template>
    <div
            class="upload-zone"
            id="uploadZone"
            @dragover.prevent="handleDragOver"
            @dragleave="handleDragLeave"
            @drop.prevent="handleDrop"
            @click="triggerInput"
    >
        <span class="upload-icon">📹</span>
        <p class="upload-text">拖拽视频文件到此处或点击上传</p>
        <button class="upload-btn">选择文件</button>
        <input
                type="file"
                class="file-input"
                id="fileInput"
                accept="video/*,image/*"
                multiple
                @change="handleFileChange"
                ref="fileInput"
        />
    </div>
</template>

<script>
export default {
    name: 'UploadZone',
    methods: {
        triggerInput() {
            this.$refs.fileInput.click(); // 触发文件输入框点击事件
        },
        handleDragOver(event) {
            event.dataTransfer.dropEffect = 'copy'; // 设置拖拽效果
            this.$el.classList.add('drag-over'); // 添加拖拽样式
        },
        handleDragLeave() {
            this.$el.classList.remove('drag-over'); // 移除拖拽样式
        },
        handleDrop(event) {
            this.$el.classList.remove('drag-over'); // 移除拖拽样式
            const files = event.dataTransfer.files; // 获取拖拽的文件
            this.$emit('files-uploaded', files); // 触发事件，将文件传递给父组件
        },
        handleFileChange(event) {
            const files = event.target.files; // 获取选择的文件
            this.$emit('files-uploaded', files); // 触发事件，将文件传递给父组件
        }
    }
};
</script>

<style scoped>
.upload-zone {
    border: 2px dashed rgba(0, 255, 150, 0.3);
    border-radius: 12px;
    padding: 0.8rem 2rem;
    text-align: center;
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
    width: 90%;
    margin: auto;
}

.upload-zone:hover {
    border-color: #00ff96;
    background: rgba(0, 255, 150, 0.05);
}

.upload-zone.drag-over {
    border-color: #00ff96;
    background: rgba(0, 255, 150, 0.1);
}

.upload-icon {
    font-size: 3rem;
    margin-bottom: 1rem;
    display: block;
}

.upload-text {
    color: #94a3b8;
    margin-bottom: 1rem;
}

.upload-btn {
    background: linear-gradient(135deg, #00ff96, #00d4ff);
    color: #0a0e27;
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.upload-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(0, 255, 150, 0.3);
}

.file-input {
    display: none;
    visibility: hidden;
}
</style>